import { render, staticRenderFns } from "./TrustsList.vue?vue&type=template&id=7a34e0b9"
import script from "./TrustsList.vue?vue&type=script&lang=js"
export * from "./TrustsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports